import { render } from "./ImprestChiefAccountantPage.vue?vue&type=template&id=40db2b39"
import script from "./ImprestChiefAccountantPage.vue?vue&type=script&lang=js"
export * from "./ImprestChiefAccountantPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__